import router from '@/router';

const state = {
  alerts: [],
  redirect: null,
};

export const getters = {
  firstUnviewedAlert(state) {
    const alerts = state.alerts.filter(a => a.visible && !a.persistant);
    if (alerts.length > 0) {
      return alerts[0];
    }
    return null;
  },
};

export const actions = {
  addAlerts({ commit, state, dispatch }, args) {
    if (args.alerts.length > 0) {
      for (let i = 0; i < args.alerts.length; i += 1) {
        const alert = args.alerts[i];
        if (alert.msgId || alert.msgFile) {
          const key = `${alert.msgId}|${alert.msgFile}`;
          if (state.alerts.find(x => `${x.msgId}|${x.msgFile}` === key && x.visible) == null) {
            commit('add', alert);
          }
        } else {
          commit('add', alert);
        }
      }
    }

    commit('redirect', args.redirect);
    dispatch('checkRedirect');
  },

  checkRedirect({ state, commit, getters }) {
    if (
      state.redirect &&
      (state.redirect.name === 'OrderCreated' ||
        state.redirect.name === 'OrderModified' ||
        getters.firstUnviewedAlert === null)
    ) {
      router.push(state.redirect);
      commit('redirect', null);
    }
  },

  remove({ dispatch, commit }, alert) {
    if (alert.bloquant) {
      commit('redirect', null);
    }

    commit('remove', alert);
    dispatch('checkRedirect');
  },
};

export const mutations = {
  add(state, alert) {
    let a = alert;
    if (!a) {
      a = {};
    }

    if (!a.title) {
      a.title = 'Erreur';
    }

    if (!a.message) {
      a.message =
        "Une erreur s'est produite lors du traitement de la requête. Si le problème persiste, veuillez nous contacter.";
    }

    if (!a.icon) {
      a.icon = 'error_outline';
    }

    if (!a.variant) {
      a.variant = 'danger';
    }

    a.visible = true;
    a.date = new Date();

    if (a.code === 500) {
      if (state.alerts.filter(x => x.code === 500 && x.visible).length > 0) {
        return;
      }
    }

    state.alerts.push(a);
  },
  remove(state, alert) {
    const a = alert;
    a.visible = false;
  },
  clear(state) {
    state.alerts.splice(0, state.alerts.length);
  },
  redirect(state, payload) {
    state.redirect = payload;
  },
  removeById(state, arg) {
    state.alerts = state.alerts.filter(alert => alert.msgFile
      !== arg.msgFile || alert.msgId !== arg.msgId);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
